import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { Button } from "semantic-ui-react";
import { RecordingContext } from "../pages/RecordingPage";

const RecordingNavigationButtons = () => {
  const isRecording = useSelector((state) => state.microphone.isRecording);
  const { changeRecording } = useContext(RecordingContext);
  return (
    <Button.Group style={{ display: "block", marginBottom: "20px" }}>
      <Button
        content="Previous"
        icon="left arrow"
        labelPosition="left"
        onClick={() => changeRecording("prev")}
        disabled={isRecording}
      />
      <Button
        content="Next"
        icon="right arrow"
        labelPosition="right"
        onClick={() => changeRecording("next")}
        disabled={isRecording}
      />
    </Button.Group>
  );
};

export default RecordingNavigationButtons;
